import { css } from '@emotion/css';
import { useDispatch } from 'react-redux';
import { logout } from 'src/actions';
import { ColorConstant } from 'src/styles';

import { MenuItem } from './MenuItem';

interface LogoutMenuItemProps {
  onClick: () => void;
}

const baseStyle = css({
  color: ColorConstant.RED5,
});

export const LogoutMenuItem = ({ onClick }: LogoutMenuItemProps) => {
  const dispatch = useDispatch();

  return (
    <MenuItem
      name='Log out'
      className={baseStyle}
      onClick={() => {
        onClick();
        dispatch(logout());
      }}
    />
  );
};
